import forms from "@tailwindcss/forms";
import typography from "@tailwindcss/typography";
import colors from "tailwindcss/colors";
import defaultTheme from "tailwindcss/defaultTheme";
import plugin from "tailwindcss/plugin";

export default {
    content: [
        "./vendor/laravel/framework/src/Illuminate/Pagination/resources/views/*.blade.php",
        "./storage/framework/views/*.php",
        "./resources/**/*.blade.php",
        "./resources/**/*.js",
        "./resources/**/*.vue",
        "./app/Models/GeoArea.php",
        "./app/Models/GeoSubArea.php",
        "./app/Models/GeoSubArea.php",
        "./app/View/Components/BusinessReviews.php",
    ],
    theme: {
        extend: {
            boxShadow: {
                DEFAULT:
                    "0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.02)",
                md: "0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.02)",
                lg: "0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.01)",
                xl: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.01)",
            },
            colors: {
                gray: colors.slate,
                "light-blue": colors.sky,
                red: colors.rose,
                peach: {
                    100: "#FBE9DF",
                    200: "#F7CEB8",
                    500: "#F3B391",
                    700: "#EC854D",
                },
                cadet: {
                    DEFAULT: "#242647",
                    50: "#f2f4fc",
                    100: "#e2e7f7",
                    200: "#ccd6f1",
                    300: "#aabce6",
                    400: "#8199d9",
                    500: "#637ace",
                    600: "#4f5fc1",
                    700: "#454fb0",
                    800: "#3d4290",
                    900: "#353a73",
                    950: "#242647", // default
                    990: "#181a33",
                },
                shazam: {
                    DEFAULT: "#0088ff",
                    50: "#edfbff",
                    100: "#d6f4ff",
                    200: "#b5eeff",
                    300: "#83e6ff",
                    400: "#48d5ff",
                    500: "#1eb8ff",
                    600: "#069cff",
                    700: "#0088ff",
                    800: "#0867c5",
                    900: "#0d599b",
                    950: "#0e355d",
                },

                orchid: {
                    DEFAULT: "#fcc2d7",
                },
                mimi: {
                    DEFAULT: "#FCC2D7",
                    25: "#fffbfe",
                    50: "#fdf2f6",
                    100: "#fde6ee",
                    200: "#fcc2d7", // default
                    300: "#fca5c2",
                    400: "#f96d99",
                    500: "#f24275",
                    600: "#e1214e",
                    700: "#c41237",
                    800: "#a2122e",
                    900: "#87142a",
                    950: "#530413",
                },
                brightred: {
                    DEFAULT: "#e63462",
                },
                ygreen: {
                    DEFAULT: "#EEF5DB",
                },
            },
            outline: {
                blue: "2px solid rgba(0, 112, 244, 0.5)",
            },
            fontFamily: {
                inter: ["Inter", "sans-serif"],
                sans: ["Nunito", ...defaultTheme.fontFamily.sans],
                brico: ["Bricolage Grotesque", "sans-serif"],
            },
            fontSize: {
                xs: ["0.75rem", { lineHeight: "1.5" }],
                sm: ["0.875rem", { lineHeight: "1.5715" }],
                base: ["1rem", { lineHeight: "1.5", letterSpacing: "-0.01em" }],
                lg: [
                    "1.125rem",
                    { lineHeight: "1.5", letterSpacing: "-0.01em" },
                ],
                xl: [
                    "1.25rem",
                    { lineHeight: "1.5", letterSpacing: "-0.01em" },
                ],
                "2xl": [
                    "1.5rem",
                    { lineHeight: "1.33", letterSpacing: "-0.01em" },
                ],
                "3xl": [
                    "1.88rem",
                    { lineHeight: "1.33", letterSpacing: "-0.01em" },
                ],
                "4xl": [
                    "2.25rem",
                    { lineHeight: "1.25", letterSpacing: "-0.02em" },
                ],
                "5xl": [
                    "3rem",
                    { lineHeight: "1.25", letterSpacing: "-0.02em" },
                ],
                "6xl": [
                    "3.75rem",
                    { lineHeight: "1.2", letterSpacing: "-0.02em" },
                ],
            },
            screens: {
                xs: "480px",
            },
            borderWidth: {
                3: "3px",
            },
            minWidth: {
                36: "9rem",
                44: "11rem",
                56: "14rem",
                60: "15rem",
                72: "18rem",
                80: "20rem",
            },
            maxWidth: {
                "8xl": "88rem",
                "9xl": "96rem",
            },
            zIndex: {
                60: "60",
            },
            keyframes: {
                "loading-bar": {
                    "0%": { width: "0%", left: "0%" },
                    "50%": { width: "50%", left: "25%" },
                    "100%": { width: "0%", left: "100%" },
                },
                "gradient-x": {
                    "0%, 100%": {
                        "background-size": "200% 200%",
                        "background-position": "left center",
                    },
                    "50%": {
                        "background-size": "200% 200%",
                        "background-position": "right center",
                    },
                },
                "bounce-gentle": {
                    "0%, 100%": {
                        transform: "translateY(-5%)",
                        "animation-timing-function":
                            "cubic-bezier(0.8, 0, 1, 1)",
                    },
                    "50%": {
                        transform: "translateY(0)",
                        "animation-timing-function":
                            "cubic-bezier(0, 0, 0.2, 1)",
                    },
                },
            },
            animation: {
                "loading-bar": "loading-bar 2s ease-in-out infinite",
                "gradient-x": "gradient-x 15s ease infinite",
                "bounce-gentle": "bounce-gentle 3s infinite",
            },
        },
    },
    plugins: [
        // eslint-disable-next-line global-require
        forms,
        typography,
        // add custom variant for expanding sidebar
        plugin(({ addVariant, e }) => {
            addVariant("sidebar-expanded", ({ modifySelectors, separator }) => {
                modifySelectors(
                    ({ className }) =>
                        `.sidebar-expanded .${e(
                            `sidebar-expanded${separator}${className}`
                        )}`
                );
            });
        }),
    ],
};
